var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAccountDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#ff7e74;}.cls-3{fill:#ffe9e9;}.cls-4{fill:#ff4a4a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.37,
    y: 0.46,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.37,
    y: 0.46,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "delete_account",
    "data-name": "delete account"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.56,
    y: 102,
    width: 405,
    height: 497,
    rx: 49.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 62.39,
    y: 360.04,
    width: 270.61,
    height: 52.26,
    rx: 26.13,
    transform: "translate(583.86 188.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 166.91,
    y: 360.04,
    width: 270.61,
    height: 52.26,
    rx: 26.13,
    transform: "translate(688.39 83.95) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 271.44,
    y: 360.04,
    width: 270.61,
    height: 52.26,
    rx: 26.13,
    transform: "translate(792.92 -20.58) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.57,
    y: -0.33,
    width: 117.3,
    height: 117.3,
    rx: 58.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 24.56,
    y: 58,
    width: 550,
    height: 133,
    rx: 66.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccountDelete);
export default __webpack_public_path__ + "static/media/user_account_delete.9b2d78425a1af2700b274b8e1579582b.svg";
export { ForwardRef as ReactComponent };